import React, { Component } from "react"
import { Modal, Button } from "react-bootstrap"
import ReactQuill from "react-quill-v2.0"
import incidentParams from "../../EmployeeOverview/WorkersComp/Incident/IncidentParams"
import "./ExpandedRichText.css"

interface ExpandedRichTextProps {
    type: string
    eventKey: string
    toggleKey: string
    text: string
    setEventType: Function
    handleQuill: Function
    // saveIncident: Function
    toggleEditor: Function
    dirty: boolean
    // saving: boolean
    readOnly?: boolean
}

class ExpandedRichText extends Component<ExpandedRichTextProps, {}> {

    formats = ["font", "color", "header", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "indent", "link"]

    componentDidMount() {
        let accordion = document.getElementById("accordion-r2-header")
        if (accordion) {
            accordion.click()
        }
    }

    componentWillUnmount() {
        let accordion = document.getElementById("accordion-r2-header")
        if (accordion) {
            accordion.click()
        }
    }

    formatRb = (keys: Array<string>) => {
        let rb: any = {}
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i]
            let value = incidentParams[key]
            rb[key] = value
        }
        return rb
    }

    render() {
        return (
            <Modal
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                size="xl"
            >
                <Modal.Header>
                    <div className="ExpandedRichTextHeader">
                        <p>{this.props.type}</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="ExpandedRichTextBody">
                        <ReactQuill
                            value={this.props.text}
                            onFocus={() => this.props.setEventType(this.props.eventKey)}
                            onChange={(e) => this.props.handleQuill(e)}
                            formats={this.formats}
                            readOnly={this.props.readOnly}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="ExpandedRichTextFooter">
                        {/* {!this.props.saving && <Button id="expanded-rich-text-close-btn" variant="secondary" onClick={() => this.props.toggleModal(this.props.toggleKey)}>Close</Button>} */}
                        {/* {!this.props.saving && this.props.dirty && <Button id="expanded-rich-text-save-btn" variant="primary" onClick={() => this.props.saveIncident(this.formatRb(IncidentKeys.UpdateWorkCompIncidentPostKeys))}>Ok</Button>} */}
                        <Button id="expanded-rich-text-save-btn" variant="primary" onClick={() => this.props.toggleEditor(this.props.toggleKey)}>Ok</Button>
                        {/* {this.props.saving && <Spinner id="rich-text-saving-spinner" animation="border" />} */}
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ExpandedRichText